<template>
  <app-widget 
    :title="$t('common.map.title')"
    :loading="loading">
    <main-map 
      v-if="markers && markers.length"
      :displayPath="false"
      :markers="markers"
      :mapPositionCoordinates="mapPositionCoordinates"
      slot="widget-content"
      @onMarkerClicked="updateSelectedDevice"
      :selected-marker="selectedDevice" />
    <p 
      v-if="!loading && (!markers || !markers.length)"
      class="text-center"
      slot="widget-content">
      {{ $t('common.map.noData') }}
    </p>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/widgets/AppWidget';
import MainMap from '@/components/maps/Main';

export default {
  name: 'DevicesMap',
  props: {
    markers: Array,
    mapPositionCoordinates: Object,
    onDeviceSelected: Function,
    selectedDevice: Object,
    loading: Boolean
  },
  methods: {
    updateSelectedDevice(device) {
      this.$emit('onDeviceSelected', device);
    }
  },
  components: {
    AppWidget,
    MainMap
  }
}
</script>